export const productConfig = {
    displayName: "DeltaBeacon",
    refreshIntervalSeconds: 60,
    minRefreshIntervalSeconds: 30,
    maxRefreshIntervalSeconds: 300,
    defaultThresholds: [30, 50, 80, 100],
    resetOffsetPercentagePoints: 5,
    resetHoldMinutes: 30,
    mobilePageSize: 500,
    adminPageSize: 20,
};
export const brand = {
    colors: {
        canvas: "#F7FAFC",
        surface: "#FFFFFF",
        ink: "#0B1526",
        muted: "#66758B",
        line: "#DCE6F0",
        blue: "#1177FF",
        cyan: "#00C2D7",
        blueSoft: "#EAF3FF",
        up: "#12A86B",
        upSoft: "#E9F8F1",
        down: "#E3484F",
        downSoft: "#FFF0F1",
        warning: "#D48A00",
    },
    radius: {
        card: 24,
        control: 14,
        pill: 999,
    },
};
